// extracted by mini-css-extract-plugin
export var availability = "Availability-module--availability--21XBk";
export var available = "Availability-module--available--2pDfE";